import {connect} from "react-redux";

import {setCameFromPage, toggleConfirmPopup, toggleSelectionFeatureInfo} from "../../../actions/actionFunctions";
import {setSqftFromFeature} from "../../../actions/sqftFunctions";
import {withRouter} from "react-router-dom";
import {setShowAddedToTheCartSuccess} from "../../../actions/groheFunctions";
import {useCloseSQFTCalc} from "./useCloseSQFTCalc";

const WithCloseSQFtCalc = (props) => {
  const {children} = props;
  const {closeSQFTCalc} = useCloseSQFTCalc();

  return children(closeSQFTCalc);
};

const mapStateToProps = (store) => ({
  cameFromPage: store.cartState.cameFromPage,
  activePreset: store.bathroomVisualizerState.activePreset,
  bvPresets: store.bathroomVisualizerState.bvPresets,
});

const mapDispatchToProps = {
  toggleSelectionFeatureInfo,
  setCameFromPage,
  toggleConfirmPopup,
  setSqftFromFeature,
  setShowAddedToTheCartSuccess,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(WithCloseSQFtCalc)
);
